import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.reducers';

const getUsersState = createFeatureSelector<UserState>('users');

const getIsFetching = createSelector(getUsersState, (state: UserState) => state.isFetching);
const getUsers = createSelector(getUsersState, (state: UserState) => state.users);

export const usersQuery = {
  getIsFetching,
  getUsers
}